module.exports = __webpack_public_path__ + "static/media/alexandra-daddario-lose.4126f7e2.jpg";